import { mapState } from 'pinia'

import { useConfigStore } from '../stores/config'

export default {
  computed: {
    ...mapState(useConfigStore, ['rsConfig'])
  },
  methods: {
    /**
     * For the cover image overlay on the teaser, we have stored URLs with a fixed
     * image size in the database from the previous integration.
     * For the new integration, the image size is requested to fit the viewport.
     * For this purpose, the URL is first generated in the client,
     * and therefore, we will only store the magazine name.
     */
    coverImageUrl (magazine, width, seoName = 'auto', type = 'webp') {
      if (seoName === 'auto') seoName = `titelbild-der-zeitschrift-${magazine}`
      return `${this.rsConfig.imageServiceUrl}/${seoName},id=${magazine},b=cover-images,w=${width},rm=sk.${type}`
    },
    /**
     * Fallback for the old database value to extract the magazine name from the URL,
     * provided the value matches the URL scheme.
     * If this is not the case, the magazine name must be used as the new value.
     */
    extractMagazineName (oldCoverUrl) {
      const match = oldCoverUrl.match(/^https:\/\/cdn\.xceler8\.io\/cover\/([^\/]+)\.jpg$/)
      return this.mapMagazineName(match ? match[1] : oldCoverUrl)
    },
    /**
     * We've previously written magazine names with multiple words together and now separate them with a hyphen.
     * Therefore, we need a small mapping for the fallback.
     */
    mapMagazineName (name) {
      const mapping = {
        allesfuerdiefrau: 'alles-fuer-die-frau',
        aufeinenblick: 'auf-einen-blick',
        dasneueblatt: 'das-neue-blatt',
        neuepost: 'neue-post',
        schoenewoche: 'schoene-woche',
        meinlieblingsrezept: 'mein-lieblingsrezept',
        wocheheute: 'woche-heute',
        dasneue: 'das-neue',
        machmalpause: 'mach-mal-pause'
      }
      return mapping[name] || name
    }
  }
}
